export const HOMEOPATHY_ENCYCLOPEDIA_DATA = [
  {
    section: 1,
    name: "Fundamentals",
    chapters: [
      { ind: 1, name: "Introduction to Homeopathy", subChapters: {} },
      { ind: 2, name: "Principles of Homeopathic Medicine", subChapters: {} },
    ],
  },
  {
    section: 2,
    name: "Analysis",
    chapters: [
      {
        ind: 1,
        name: "Constitutional Analysis in Homeopathy",
        subChapters: {},
      },
    ],
  },
  {
    section: 3,
    name: "Therapeutics",
    chapters: [
      { ind: 1, name: "Homeopathic Remedies", subChapters: {} },
      { ind: 2, name: "Case Taking and Repertorization", subChapters: {} },
      { ind: 3, name: "Materia Medica", subChapters: {} },
      { ind: 4, name: "Potentization and Dilution", subChapters: {} },
      { ind: 5, name: "Organon of Medicine", subChapters: {} },
      { ind: 6, name: "Homeopathic Philosophy", subChapters: {} },
      { ind: 7, name: "Homeopathic First Aid", subChapters: {} },
      {
        ind: 8,
        name: "Homeopathic Management of Chronic Diseases",
        subChapters: {},
      },
      { ind: 9, name: "Homeopathic Pediatrics", subChapters: {} },
      { ind: 10, name: "Homeopathy and Mental Health", subChapters: {} },
    ],
  },
  {
    section: 4,
    name: "Specific Conditions",
    chapters: [
      {
        ind: 1,
        name: "Cardiovascular Health",
        subChapters: {
          1: "Hypertension",
          2: "Heart Palpitations",
          3: "Angina",
        },
      },
      {
        ind: 2,
        name: "Digestive Disorders",
        subChapters: {
          1: "Indigestion",
          2: "Acid Reflux",
          3: "Irritable Bowel Syndrome",
          4: "Constipation",
        },
      },
      {
        ind: 3,
        name: "Respiratory Health",
        subChapters: {
          1: "Asthma",
          2: "Bronchitis",
          3: "Allergic Rhinitis",
        },
      },
      {
        ind: 4,
        name: "Musculoskeletal Health",
        subChapters: {
          1: "Arthritis",
          2: "Back Pain",
          3: "Sports Injuries",
        },
      },
      {
        ind: 5,
        name: "Women's Health",
        subChapters: {
          1: "Menstrual Disorders",
          2: "Menopause",
          3: "Pregnancy and Homeopathy",
        },
      },
      {
        ind: 6,
        name: "Children's Health",
        subChapters: {
          1: "Common Childhood Ailments",
          2: "Autism Spectrum Disorders",
          3: "Attention Deficit Hyperactivity Disorder (ADHD)",
        },
      },
      {
        ind: 7,
        name: "Mental and Emotional Wellbeing",
        subChapters: {
          1: "Anxiety",
          2: "Depression",
          3: "Stress Management",
        },
      },
      {
        ind: 8,
        name: "Skin Conditions",
        subChapters: {
          1: "Eczema",
          2: "Psoriasis",
          3: "Acne",
        },
      },
      {
        ind: 9,
        name: "Infectious Diseases",
        subChapters: {
          1: "Influenza",
          2: "Common Cold",
          3: "COVID-19",
        },
      },
      {
        ind: 10,
        name: "Allergies and Sensitivities",
        subChapters: {
          1: "Food Allergies",
          2: "Environmental Allergies",
          3: "Chemical Sensitivities",
        },
      },
    ],
  },
];
